export const PurchaseOrder = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 11H8M10 15H8M16 7H8M20 10.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H11.5"
        stroke="#99A0AE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip0_16191_311105)">
        <path
          d="M22.25 15.6372L18 17.9983M18 17.9983L13.75 15.6372M18 17.9983L18 22.7483M19 22.4428L18.3885 22.7825C18.2467 22.8613 18.1758 22.9007 18.1007 22.9161C18.0343 22.9298 17.9657 22.9298 17.8993 22.9161C17.8242 22.9007 17.7533 22.8613 17.6115 22.7825L13.9115 20.7269C13.7617 20.6437 13.6868 20.6021 13.6323 20.543C13.5841 20.4906 13.5476 20.4286 13.5252 20.361C13.5 20.2846 13.5 20.1989 13.5 20.0276V15.9691C13.5 15.7977 13.5 15.7121 13.5252 15.6357C13.5476 15.5681 13.5841 15.506 13.6323 15.4537C13.6868 15.3945 13.7617 15.3529 13.9115 15.2697L17.6115 13.2142C17.7533 13.1354 17.8242 13.096 17.8993 13.0806C17.9657 13.0669 18.0343 13.0669 18.1007 13.0806C18.1758 13.096 18.2467 13.1354 18.3885 13.2142L22.0885 15.2697C22.2383 15.3529 22.3132 15.3945 22.3677 15.4537C22.4159 15.506 22.4524 15.5681 22.4748 15.6357C22.5 15.7121 22.5 15.7977 22.5 15.9691L22.5 18.2483M15.75 14.2483L20.25 16.7483M20 20.9983L21 21.9983L23 19.9983"
          stroke="#99A0AE"
          strokeWidth="1.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16191_311105">
          <rect width="12" height="12" fill="white" transform="translate(12 12)" />
        </clipPath>
      </defs>
    </svg>
  );
};
